import React from 'react'
import { DASHBOARD_CONTEXT } from '@trustero/trustero-api-web/lib/dashboard/dashboard_pb'
import { FilterName, FilterParam } from '../../../FilterBar.types'
import { DashboardDimensionFilterDropdown } from './DashboardDimensionFilterDropdown'

export const DashboardEmailFilterDropdown = ({
  isNested = false,
  dashboardContext,
  dashboardName,
}: {
  isNested?: boolean
  dashboardContext?: DASHBOARD_CONTEXT
  dashboardName?: string
}): JSX.Element | null =>
  dashboardContext !== undefined && dashboardName !== undefined ? (
    <DashboardDimensionFilterDropdown
      filterParam={FilterParam.DASHBOARD_EMAIL_DIMENSION}
      filterName={FilterName.DASHBOARD_EMAIL_DIMENSION}
      dashboardContext={dashboardContext}
      dashboardName={dashboardName}
      dimension="email"
      undefinedString="Unknown"
      isNested={isNested}
    />
  ) : null
